import OneColumnLayout from '@/layouts/OneColumnLayout.vue';

export default [
  {
    path: 'conversation-tips',
    name: 'conversation-tips',
    component: () => import('@/views/studentResources/ConversationTips.vue' as any),
    meta: {
      layout: OneColumnLayout,
      renderNav: true,
      // Anonymous visitors reach this page by a link and have access to nothing else, so
      // the nav would be a list of destinations they cannot open. Signed-in users get it.
      navRequiresAuth: true,
      bypassAuth: true,
      title: 'Conversation Tips',
    },
  },
];
